import React, { useEffect, useMemo, useState } from "react";
import { Row, Col, Form, Card } from "react-bootstrap";
import { connect } from "react-redux";
import { setHeading } from "../../../accounts/account.actions";
import { AddMasterControlApi, GetMasterControlApi } from "./MasterControl.action";
import { GetLevelFourDropDownApi } from "../../AccountsModule/LevelFour/LevelFourAction";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import Select from "react-select";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";


const AccountsIntegration = (props) => {
  const [accounts, setAccounts] = useState({
    invoiceSalesAccount: null,
    cashReceiveAccount: null,
    cashReceiveDiscountAccount: null,
  });

  const accountOptions = useMemo(() => {
    return props.levelFourDropDownList?.map((x) => ({
      value: x._id,
      label: x.levelFourName,
    })) || [];
  }, [props.levelFourDropDownList]);

  useEffect(() => {
    if (props.masterControlDataList?.length) {
      const data = props.masterControlDataList[0];

      setAccounts({
        invoiceSalesAccount: data.invoiceSalesAccount
          ? { value: data.invoiceSalesAccount._id, label: data.invoiceSalesAccount.levelFourName }
          : null,

        cashReceiveAccount: data.cashReceiveAccount
          ? { value: data.cashReceiveAccount._id, label: data.cashReceiveAccount.levelFourName }
          : null,

        cashReceiveDiscountAccount: data.cashReceiveDiscountAccount
          ? { value: data.cashReceiveDiscountAccount._id, label: data.cashReceiveDiscountAccount.levelFourName }
          : null,
      });
    }
  }, [props.masterControlDataList]);

  const handleChange = (field) => (selected) => {
    setAccounts((prev) => ({
      ...prev,
      [field]: selected,
    }));
  };

  const saveAccounts = () => {
    props.AddMasterControlApi(
      {
        invoiceSalesAccount: accounts.invoiceSalesAccount?.value || null,
        cashReceiveAccount: accounts.cashReceiveAccount?.value || null,
        cashReceiveDiscountAccount: accounts.cashReceiveDiscountAccount?.value || null,
      },
      showSuccessAlert,
      showErrorAlert
    );
  };

  useEffect(() => {
    props.setHeading("Account Integration");
    props.GetLevelFourDropDownApi();
    props.GetMasterControlApi();
  }, []);

  if (props.isAddingMasterControl || props.isFetchingLevelFourDropDown || props.isFetchingMasterControl) {
    return <GlobalSpinner />;
  }

  const sections = [
    {
      title: "SECTION-1 INVOICE",
      badge: "ACCOUNTS",
      fields: [
        {
          label: "Invoice Sales Account",
          field: "invoiceSalesAccount",
          placeholder: "Select Invoice Sales Account",
        },
      ],
    },
    {
      title: "SECTION-2 PAYMENT RECEIVED",
      badge: "STORE",
      fields: [
        {
          label: "Cash Receive Account",
          field: "cashReceiveAccount",
          placeholder: "Select Cash Receive Account",
        },
        {
          label: "Cash Receive Discount Account",
          field: "cashReceiveDiscountAccount",
          placeholder: "Select Discount Account",
        },
      ],
    },
  ];

  return (
    <Form>
      {sections.map((section, index) => (
        <Card key={index} className="mb-4 shadow-sm">
          {/* <Card.Header> <h5 className="mb-0">{section.title}</h5></Card.Header> */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "0.75rem 1.25rem", background: '#E6F1FB', borderBottom: `0.5px solid #B5D4F4` }} >
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: '#185FA5' }} />
            <span style={{ fontSize: 13, fontWeight: 600, color: '#0C447C', letterSpacing: "0.04em", textTransform: "uppercase" }} >
              {section.title}
            </span>
            <span style={{ marginLeft: "auto", fontSize: 12, color: '#185FA5', background: '#B5D4F4', borderRadius: 4, padding: "2px 8px", fontWeight: 500, }} >
              {section.badge}
            </span>
          </div>

          <Card.Body>
            <Row>
              {section.fields.map((item, i) => (
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label><b>{item.label} *</b></Form.Label>
                    <Select
                      placeholder={item.placeholder}
                      options={accountOptions}
                      value={accounts[item.field]}
                      onChange={handleChange(item.field)}
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
      ))}

      <div className="sendDiv">
        <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={saveAccounts}>UPDATE</Button>
      </div>

    </Form>
  );
};

const mapDispatchToProps = (dispatch) => ({
  AddMasterControlApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddMasterControlApi(data, showSuccessAlert, showErrorAlert)),
  GetLevelFourDropDownApi: () => dispatch(GetLevelFourDropDownApi()),
  GetMasterControlApi: () => dispatch(GetMasterControlApi()),
  setHeading: (data) => dispatch(setHeading(data)),
});

const mapStateToProps = (state) => ({
  isAddingMasterControl: state.MasterControlReducer.isAddingMasterControl,
  isFetchingLevelFourDropDown: state.LevelFourReducer.isFetchingLevelFourDropDown,
  levelFourDropDownList: state.LevelFourReducer.levelFourDropDownList,
  masterControlDataList: state.MasterControlReducer.masterControlDataList,
  isFetchingMasterControl: state.MasterControlReducer.isFetchingMasterControl,
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountsIntegration);